var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDermastamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.33 282.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 22.29px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: #7a3516;\n      }\n\n      .cls-1, .cls-3 {\n        font-family: PalatinoLinotype-Bold, 'Palatino Linotype';\n        font-weight: 700;\n      }\n\n      .cls-4 {\n        fill: #f2f0f2;\n      }\n\n      .cls-5 {\n        fill: #8d695d;\n      }\n\n      .cls-3 {\n        font-size: 50.8px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.06,167.03h7.24v-25.11c0-.09-.28-.45-.33-.59-.15-.45-.13-1.01,0-1.47.04-.16.34-.63.34-.74v-22.62h-7.24v-.57h25.38c6.74.25,13.98,1.55,19.05,6.3,5.63,5.27,6.91,13.67,6.63,21.07-.37,9.49-4.33,17.53-13.19,21.59-4.22,1.93-8.8,2.59-13.41,2.71-8.09.21-16.22-.08-24.32.04-.04,0-.13-.03-.13-.06v-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.37,142.31c3.43,3.29,6.65,7.15,9.09,11.23.34.57.9,1.46,1.14,2.04.16.4-.18.72-.35,1.07-.58,1.21-1.22,2.4-2.05,3.47-3.06,3.93-7.51,5.53-12.39,5.57-2.82.03-6.78-.02-8.17-2.97-.21-.45-.36-.97-.36-.97-.29-.97-.33-1.81-.32-2.36.29-.1.77-.25,1.36-.43,1.38-.43,2.49-.75,2.71-.81,1.39-.39,4.73-1.33,7.61.1.69.34,2,1.14,3.12,2.99.17.36.35.71.52,1.07.01-.2-.01-.4-.05-.6-.27-1.53-.79-3.85-2.04-4.89-.46-.38-1.19-.85-1.71-1.13-2.68-1.42-5.36-1.23-8.2-.47-1.51.4-2.96,1.01-4.53,1.21-.32.04-.99-.12-1.24-.32-.56-.45-.32-1.33-.12-1.92.2-.59.45-1.17.54-1.8.1-.71-.3-1.25-.73-1.76-.38-.45-1.21-.98-.29-1.48.27-.15.44-.2.73-.31.21-.08.5-.21.82-.43-.02-.14-.39-.12-.5-.15-.47-.1-1.33-.2-1.69-.49-.05-.04-.12-.11-.14-.16-.04-.11-.05-.64-.02-.77.02-.09.1-.13.12-.18.4-.92.88-2.47.42-3.44-.44-.92-1.79-1.7-2.56-2.38-.37-.32-.58-.49-.19-.92.26-.29.6-.49.88-.73,1.94-1.7,4.57-3.97,5.42-6.42.57-1.65.7-3.86.73-5.63,0-.1.04-.2.04-.3,0-.09-.11-.59.02-.59l.65,1.91c1.74,4.49,4.11,7.74,7.85,10.77,1.36,1.1,2.64,2.18,3.9,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.05,121.54c4.55,3.76,6.83,9.74,7.56,15.4.23,1.8.37,3.66.34,5.48,0,.43-.02,1.35-.08,3.18-.04,1.13-.07,1.87-.2,1.88-.12.01-.25-.56-.28-.63-2.56-6.24-8.44-10.55-12.91-15.4-4.43-4.8-6.63-8.29-8.04-12.41-.19-.55-.33-1-.41-1.31.81-.09,1.95-.16,3.29-.07,1.71.11,6.63.5,10.73,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.55,116.48c0,.15.02.37.05.62.02.17.08.71.3,1.57,0,0,.17.46.26.89.66,3.11,1.92,6.32,3.57,9.07,1.83,3.04,4.4,5.63,7,8.05,1.54,1.42,3.14,2.78,4.6,4.33,2.6,2.76,4.53,5.93,5.68,9.49.3.93.55,1.92.72,2.88.05.29.21.59.19.92-.22.1-.16-.09-.2-.22-2.38-6.37-7.64-12.52-12.89-16.83-.51-.41-1.03-.81-1.52-1.2,0,0-4.82-4.22-7.25-12.02-.26-.85-.45-1.65-.45-1.65-.2-.86-.3-1.5-.44-2.43-.14-.96-.28-1.91-.43-2.87-.03-.2-.16-.37-.1-.6h.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.21,127.74c-.08.01-.09,0-.08-.08l.08.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.74,117.47s-.04.14-.05.15c-.07.1-.1-.02-.05-.1,0-.14.04-.17.05-.25-.04.07.05.18.05.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.04,140.19c0,1.08-.08,2.46-.45,4.01-.28,1.17-.64,2.16-1,2.97.95.35,2.71,1.14,4.28,2.85.15.16,2.79,3.23,2.79,6.5,0,8.69-9.7,10.65-15.86,10.65-13.9,0-17.89-8.76-18.54-20.57h-.51l1.01,20.93,3.69-2.46c3.19,1.45,8.84,2.68,14.34,2.68,10.65,0,20.78-5,20.78-14.92,0-2.42-.74-4.39-1.13-5.22-2.53-5.41-8.25-7.1-9.41-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.72,137.54c-8.35.05-14.38-5.28-14.59-10.21-.25-5.94,7.99-10.28,14.09-10.87,1.35-.13,7.05-.63,11.79,3.53,3.12,2.74,4.85,7.21,5.23,13.85h.58l-.87-17.74-3.77,2.46c-2.61-1.3-7.39-2.68-12.96-2.68-6.28,0-19.39,5.57-19.41,13.9-.02,6.49,7.9,14.03,19.36,14.41.27-.53.71-1.34,1.34-2.28.59-.87.85-1.14.92-1.61.07-.53-.08-1.44-1.71-2.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.7,146.56c.61,1.13,2.33,4.71,1.42,9.16-1.44,7.06-8.2,9.9-8.77,10.13.51-.1,6.4-1.3,8.91-6.98,1.78-4.03,1.17-8.76-1.56-12.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.29,138.36c-.88,3.36-2.06,5.81-2.97,7.42-1.61,2.84-2.85,3.92-4.06,7.17-1.04,2.81-1.08,4.62-1.09,5.04-.03,2.48.7,4.44,1.23,5.59-.16-1.85.02-3.37.22-4.43.39-2.06,1.09-3.56,1.53-4.49.66-1.39.94-1.59,1.88-3.32,0,0,1.21-2.21,2-4.24.61-1.57,1.46-4.45,1.26-8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.03,129.74c.23-.28.78-.84,1.65-1.08,1.73-.48,3.15.74,3.28.85.91,1.05,2.61,2.72,5.24,3.79,1.86.76,3.59,1.46,5.11.72,2.13-1.03,3.02-4.45,3.52-6.35.13-.51.29-1.23.71-2.19.51-1.18,1.21-2.72,2.57-3.07.49-.13.93-.06,1.2,0-.79.4-1.72,1.05-2.34,2.11-.21.37-.49.94-.83,3.15-.3,1.9-.38,3.31-.38,3.31-.27,4.35-.01,4.49-.23,6.44-.35,3.1-1.29,5.36-1.55,5.97-.66,1.53-.77,1.3-2.71,4.65-1.67,2.9-2.52,4.38-3.02,6.09-.58,1.96-.67,3.73-.62,5.12-.28-2.48-.55-4.95-.83-7.43-.13-.8-.23-1.89-.13-3.19.04-.49.15-1.56.51-2.76,1.06-3.52,3.03-3.97,2.9-5.85-.08-1.12-.86-1.87-2.43-3.37-1.82-1.74-2.38-1.39-4.4-3.07-2.35-1.96-2.54-3.22-4.37-3.78-1.11-.34-2.15-.22-2.84-.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 169.96,
    cy: 130.68,
    rx: 2.06,
    ry: 2.86,
    transform: "translate(-40.04 87.49) rotate(-25.94)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.8,144.58c2.05-.12,3.67.13,4.77.38.75.17,1.31.36,2.06.61.68.23,2.24.77,4.19,1.73.77.38,1.44.74,1.81.96,1.71.99,5.21,3.01,6.22,6.44,1.05,3.55-1.08,6.91-1.61,7.69.39-1.58.88-4.66-.55-7.69-1.11-2.35-3.34-3.79-4.81-4.81-.79-.55-1.43-.9-2.4-1.44-2.74-1.53-4.89-2.36-5.35-2.53-1.11-.42-2.58-.91-4.34-1.33Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(84.69 133.07) rotate(-72.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(91.1 114.54) rotate(-55.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(99.57 102.42) rotate(-39.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(112.6 91.38) rotate(-18.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(134.84 84.58) rotate(2.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(153.45 86.17) rotate(15.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(160.36 87.81) rotate(26.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(173.59 94.66) rotate(41.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(184.43 104.91) rotate(54.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(190.93 112.58) rotate(71.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(197.2 135.16) rotate(86.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(197.8 142.27) rotate(97.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(194.69 158.86) rotate(111.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(193.05 165.73) rotate(126.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(178.47 183.87) rotate(145.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(166.15 192.09) rotate(160.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(152.14 196.8) rotate(175.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(137.45 198.1) rotate(-166.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(118.39 193.11) rotate(-149.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(105.72 185.56) rotate(-133.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(95.41 174.69) rotate(-119.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(88.5 161.28) rotate(-108.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(86.34 154.29) rotate(-100.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(84.85 147.32) rotate(-89.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDermastamp);
export default __webpack_public_path__ + "static/media/dermastamp.bf1a916397f47da4e96ea850df9ba26c.svg";
export { ForwardRef as ReactComponent };